import { lazy, Suspense } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import Home from "../../pages/home";
import NotFound from "../../pages/notFound";
const Project = lazy(() => import("../../pages/project"));
const AboutMe = lazy(() => import("../../pages/AboutMe"));
const Solotion = lazy(() => import("../../pages/solotion"));
const ArticleDetail = lazy(() => import("../../pages/ArticleDetail"));
const CookiesPolicy = lazy(() => import("../../pages/cookiesPolicy"));
const PortfolioHome = lazy(() => import("../../pages/Portfolio"));
const ServicesPage = lazy(() => import("../../pages/servicesPage/servicesPage"));
const CallBooking = lazy(() => import("../../containers/callBooking/callBooking"));
const QuoteForm = lazy(() => import("../../containers/QuoteForm/quoteForm"));
const SeoAuditForm = lazy(() => import("../../containers/seoAuditForm/seoAuditForm"));
const Contact = lazy(() => import("../../containers/contact"));
const DeveloppeuseReactSeo = lazy(() => import("../../pages/landing/DeveloppeuseReactSeo"));
const DeveloppeuseAngularSeo = lazy(() => import("../../pages/landing/DeveloppeuseAngularSeo"));
const AuditSeoTechnique = lazy(() => import("../../pages/landing/AuditSeoTechnique"));
const OptimisationPerformanceWeb = lazy(() => import("../../pages/landing/OptimisationPerformanceWeb"));
const DeveloppeuseFullStackFreelance = lazy(() => import("../../pages/landing/DeveloppeuseFullStackFreelance"));
const CreationSiteWeb = lazy(() => import("../../pages/landing/CreationSiteWeb"));
const ApplicationWeb = lazy(() => import("../../pages/landing/ApplicationWeb"));
const DeveloppementSaas = lazy(() => import("../../pages/landing/DeveloppementSaas"));
const NodeNest = lazy(() => import("../../pages/landing/NodeNest"));
const Pwa = lazy(() => import("../../pages/landing/Pwa"));

const RoutesPath = () => {
  return (
    <div>
      <Suspense fallback={<p role="status" className="pt-32 text-center">Chargement…</p>}>
      <Routes>
        <Route caseSensitive path="/" exact element={<Home />} />
        <Route caseSensitive path="/project/:slug" element={<Project />} />
        <Route caseSensitive path="/about" element={<AboutMe />} />
        <Route caseSensitive path="/AboutMe" element={<Navigate to="/about" replace />} />
        <Route caseSensitive path="/portfolio" element={<PortfolioHome />} />
        <Route caseSensitive path="/Portfolio" element={<Navigate to="/portfolio" replace />} />
        <Route caseSensitive path="/solutions" element={<Solotion />} />
        <Route caseSensitive path="/Solutions" element={<Navigate to="/solutions" replace />} />
        <Route caseSensitive path="/article/:slug" element={<ArticleDetail />} />
        <Route caseSensitive path="/services" element={<ServicesPage />} />
        <Route caseSensitive path="/call" element={<CallBooking />} />
        <Route caseSensitive path="/quote" element={<QuoteForm />} />
        <Route caseSensitive path="/contact" element={<Contact />} />
        <Route caseSensitive path="/audit" element={<SeoAuditForm />} />
        <Route caseSensitive path="/*" element={<NotFound />} />
        <Route caseSensitive path="/CookiesPolicy" element={<Navigate to="/cookiesPolicy" replace />} />
        <Route caseSensitive path="/cookiesPolicy" element={<CookiesPolicy />} />
        <Route caseSensitive
          path="/developpeuse-react-seo"
          element={<DeveloppeuseReactSeo />}
        />
        <Route
          path="/developpeuse-angular-seo"
          element={<DeveloppeuseAngularSeo />}
        />
        <Route caseSensitive path="/audit-seo-technique" element={<AuditSeoTechnique />} />
        <Route
          path="/optimisation-performance-web"
          element={<OptimisationPerformanceWeb />}
        />
        <Route
          path="/full-stack-freelance"
          element={<DeveloppeuseFullStackFreelance />}
        />
        <Route caseSensitive path="/creation-site-web" element={<CreationSiteWeb />} />
        <Route caseSensitive path="/application-web" element={<ApplicationWeb />} />
        <Route caseSensitive path="/developpement-saas" element={<DeveloppementSaas />} />
        <Route caseSensitive path="/nodejs-nestjs" element={<NodeNest />} />
        <Route caseSensitive path="/pwa" element={<Pwa />} />
      </Routes>
      </Suspense>
    </div>
  );
};
export default RoutesPath;
